import InputText from "../elements/InputText";

/**
 * Campo Telegram ID com o botão de vínculo colado à direita.
 *
 * Usa o hook getRenderInputGroupRigth() do FormField, que embrulha o input em um
 * input-group do Bootstrap - mesmo caminho do InputCopy.
 */
export default class InputTelegramId extends InputText {

    constructor(props) {
        super(props);
        this.onClickVincular = this.props.onClickVincular !== undefined ? this.props.onClickVincular : () => { };
        this.onClickDesvincular = this.props.onClickDesvincular !== undefined ? this.props.onClickDesvincular : () => { };
    }

    //props próprias deste componente não podem descer para o <input> como atributo
    getProps(props, delProps = []) {
        return super.getProps(props, [...delProps, "onClickVincular", "onClickDesvincular", "flVinculado"]);
    }

    getRenderInputGroupRigth() {

        if (this.props.flVinculado) {
            return (
                <button className="btn btn-outline-danger" type="button" onClick={this.onClickDesvincular} title="Desvincular esta conta do Telegram">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg> Desvincular
                </button>);
        }

        return (
            <button className="btn btn-outline-primary" type="button" onClick={this.onClickVincular} title="Vincular sua conta do Telegram lendo um QR Code">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-qr-code" viewBox="0 0 16 16">
                    <path d="M2 2h2v2H2V2Z" />
                    <path d="M6 0v6H0V0h6ZM5 1H1v4h4V1ZM4 12H2v2h2v-2Z" />
                    <path d="M6 10v6H0v-6h6Zm-5 1v4h4v-4H1Zm11-9h2v2h-2V2Z" />
                    <path d="M10 0v6h6V0h-6Zm5 1v4h-4V1h4ZM8 1V0h1v2H8v2H7V1h1Zm0 5V4h1v2H8ZM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8H6Zm0 0v1H2V8H1v1H0V7h3v1h3Zm10 1h-1V7h1v2Zm-1 0h-1v2h2v-1h-1V9Zm-4 0h2v1h-1v1h-1V9Zm2 3v-1h-1v1h-1v1H9v1h3v-2h1Zm0 0h3v1h-2v1h-1v-2Zm-4-1v1h1v-2H7v1h2Z" />
                    <path d="M7 12h1v3h4v1H7v-4Zm9 2v2h-3v-1h2v-1h1Z" />
                </svg> Vincular
            </button>);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}
